import BaseMarkerLayer from './BaseMarkerLayer'
import { newMarker2 } from '../../markerUtil'

/**
 * feature转marker
 * @param {*} feature
 * @param {*} title
 * @param {*} opt_options
 */
function feature2Marker(feature, title, opt_options) {
    const lngLat = [feature.geometry.x, feature.geometry.y]

    const marker = newMarker2(
        feature.attributes.markeroptions,
        opt_options
    ).setLngLat(lngLat)

    marker.id = feature.id

    if (title) {
        marker.getElement().title = feature.attributes[title]
    }

    return marker
}

/**
 * 通过feature自动生成MarkerLayer
 */
export default class FeatureMarkerLayer extends BaseMarkerLayer {
    /**
     * 初始化
     * @param {mapBox.map} map
     */
    constructor(map, title, opt_options) {
        super(map)

        // 参数
        this._title = title
        this._opt_options = opt_options

        // 内部参数
        this._features = []
    }

    /**
     * @api
     * @property
     * @param {any[]} features
     */
    set features(features) {
        this.clear()
        this._features = []
        if (features && features.length) {
            this._features = features
            this._addFeaturesToMap()
        }
    }

    /**
     * @api
     */
    fitBounds() {
        if (this._features.length) {
            const bounds = GeoGlobe.Feature.getBoundsByFeatures(this._features)
            bounds && this._map.fitBounds(bounds)
        }
    }

    /**
     * 渲染函数
     * @param {Array.<GeoGlobe.Feature>} features
     */
    _addFeaturesToMap() {
        if (!this._features.length) return
        const markersList = this._features.map(f =>
            feature2Marker(f, this._title, this._opt_options)
        )
        this.addAll(markersList)
    }
}
